export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9211.3137f23e.jpg";